import API from "./api";

export const GetModules = (configUrl: string, suffix: string) =>
  API.get(`${configUrl}api/useraccess/${suffix}`);
